
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LoadersService {
    // isLoading = new Subject<boolean>();
    isLoading:boolean = false
    // show() {
    //     this.isLoading.next(true);
    // }
    // hide() {
        // this.isLoading.next(false);
    // }
    setLoading(loading: boolean) {
      this.isLoading = loading;
    }
  
    getLoading(): boolean {
      return this.isLoading;
    }
}
